'use strict';
module.exports	= function fontMetrics(fontInfo) {
	const fontSize = (fontInfo && fontInfo.sizePx) || (fontInfo && 1.3 * fontInfo.size) || 12,
		lineSpacing = (fontInfo && fontInfo.lineSpacingPx) || (fontInfo &&  1.3 * fontInfo.lineSpacing) || 4;
	return {
		fontSize: Math.ceil(fontSize),
		lineSpacing: Math.ceil(lineSpacing),
		weight: (fontInfo && fontInfo.weight) || 'bold',
		family: (fontInfo && fontInfo.family) || 'Sans'
	};
};

